import dayjs from 'dayjs';

import { getStartEndTimeOfMultDays, useAuthContext, useSyncMealDetails } from '../data-access';

interface SyncMealDataParams {
  terraUserIds: string[];
  startDate: string;
  endDate: string;
}

export const useSyncMealData = () => {
  const { syncMealDetail } = useSyncMealDetails();
  const { user } = useAuthContext();

  const syncMealData = async ({ terraUserIds, startDate, endDate }: SyncMealDataParams) => {
    if (!user.metricId || !user.userId || !terraUserIds.length) {
      return;
    }

    const { startTime, endTime } = getStartEndTimeOfMultDays(dayjs(startDate), dayjs(endDate));

    if (terraUserIds.length) {
      try {
        await syncMealDetail({
          metricId: user.metricId,
          terraUserIds,
          startDate: startTime.toISOString(),
          endDate: endTime.toISOString(),
        });
      } catch (error) {
        console.error('Error syncing meal data', error);
      }
    }
  };

  return { syncMealData };
};
